import { Anchor } from 'components/atoms';
import React from 'react';
import { useTranslation } from 'utils/hooks';

import css from './ShutdownBanner.module.scss';

/**
 * Dauerhafter Hinweis unterhalb der Kopfzeile, dass wirtschaft.at eingestellt wird.
 * Wird auf allen Seiten angezeigt, die den Header verwenden.
 */
const ShutdownBanner: React.FC = () =>
{
  const { t, r } = useTranslation();

  return (
    <aside className={css.banner} role="status">
      <div className={css.content}>
        <p className={css.title}>{t('common:shutdown.title')}</p>
        <p>
          {r('common:shutdown.text', {
            support: <Anchor href="mailto:support@wirtschaft.at"/>,
          })}
        </p>
      </div>
    </aside>
  );
};

export default ShutdownBanner;
